import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip  } from 'recharts';
import classes from './BrightenChart.module.css';

function BrightenChart(props) {
	const col = 100;
	let width = 0;
	let height = 0;
	let labelHgt = 65;
	let theData = props.data.data[props.type];
	switch (props.type) {
		case "allCards": 		width = 6 * col;  height= 330; break;
		case "indCards": 		width = 5 * col;  height= 200; break;
		case "grpCards": 		width = 5 * col;  height= 200; break;
		case "cardGroupData": 	width = 10 * col; height = 330; labelHgt = 110;
			theData = [...props.data.data[props.type]].sort((a, b) => b.qty - a.qty); break;
		default: 				labelHgt = 65; ;
	}
	const theTick = { textAnchor: 'start' }

	return (
		<div className={classes[props.type]}>
			<h3>{props.title}</h3>
				
			<BarChart width={width} height={height} data={theData} >
				<CartesianGrid strokeDasharray="3 3" />
				<XAxis dataKey="label" angle={90} interval={0} height={labelHgt} tick={theTick} dx={4}/>
				<YAxis tickCount={10} />
				<Tooltip />
				<Bar dataKey="qty" fill="#0137E9" />
			</BarChart>
		</div>
	);
}	

export default BrightenChart;